import { buffers, eventChannel } from 'redux-saga'
import { call, cancel, flush, fork, put, take } from 'redux-saga/effects'

import { Creators, Types } from '~/state/firebase/actions'

export function createEventChannel(ref) {
  const listener = eventChannel((emit) => {
    const removeListener = ref.onSnapshot((snap) => {
      emit({
        eventType: Types.FIREBASE_LISTEN_CHILD_UPDATED,
        value: snap.data(),
      })
    })

    return () => removeListener()
  }, buffers.expanding(1))

  return listener
}

export function* getDataAndListenToChannel(ref, metaType) {
  const chan = yield call(createEventChannel, ref)
  try {
    try {
      const snap = yield call([ref, ref.get])
      yield flush(chan)
      const val = snap.data()
      const value = val || {}

      yield put(Creators.firebaseListenFulfilled(value, metaType))
    } catch (error) {
      yield put(Creators.firebaseListenRejected(error, metaType))
    }
    while (true) {
      const data = yield take(chan)
      yield put(
        Creators.firebaseListenChildUpdated(data.key, data.value, metaType),
      )
    }
  } finally {
    chan.close()
  }
}

export default function* watchListener(metaType) {
  while (true) {
    const listenRequestAction = yield take(Types.FIREBASE_LISTEN_REQUESTED)

    if (listenRequestAction.metaType === metaType) {
      let task = yield fork(
        getDataAndListenToChannel,
        listenRequestAction.ref,
        metaType,
      )
      while (true) {
        const action = yield take([
          Types.FIREBASE_REMOVE_LISTENER_REQUESTED,
          Types.FIREBASE_LISTEN_REQUESTED,
        ])

        if (action.metaType === metaType) {
          yield cancel(task)
          yield put(
            Creators.firebaseListenRemoved(!!action.clearItems, metaType),
          )

          if (action.type === Types.FIREBASE_LISTEN_REQUESTED) {
            task = yield fork(getDataAndListenToChannel, action.ref, metaType)
          } else {
            break
          }
        }
      }
    }
  }
}
